import { PaginationProps, SortDirection } from '@touche-lts/panel-ui/dist'
import {
  ProductsTableSearchProps,
  ProductsTableSortProps
} from './products-table-base.types'

export const initialProductsTablePaginationProps: PaginationProps<ProductsTableSortProps> = {
  page: 0,
  size: window.innerWidth >= 1920 ? 10 : 6,
  sortDirection: SortDirection.ASC,
  sortProp: ProductsTableSortProps.ID,
  totalElements: 0,
  totalPages: 0
}

export const initialProductsTableSearchProps: ProductsTableSearchProps = {
  id: null,
  productName: '',
  storeName: '',
  minSKUs: null,
  maxSKUs: null,
  minStock: null,
  maxStock: null,
  minSold: null,
  maxSold: null,
  minRevenue: null,
  maxRevenue: null,
  departmentName: '',
  addedOnPeriod: null
}

export const productsTableNeedTimeoutProps: Array<keyof ProductsTableSearchProps> = [
  'id',
  'productName',
  'storeName',
  'departmentName'
]
